import React from "react"

const Footer = () => (
  <footer className="pt-12 pb-12 bg-black text-white font-body">
    <div className="flex justify-between left-0 max-w-4xl mx-auto">
      <div>
        <a href="https://prsguitars.com/">www.prsguitars.com</a>
      </div>
      <div>
        © {new Date().getFullYear()}
        {` `}
        <a href="https://www.prsguitars.com">PRS Guitars</a>
      </div>
    </div>
  </footer>
)
export default Footer
